export const FLOW_RATE_MONTHS = [
	'january', 'february', 'march', 'april', 'may', 'june',
	'july', 'august', 'september', 'october', 'november', 'december',
];

/** Omite meses vacíos; convierte a número (incluye 0 y decimales). */
export const normalizeFlowRatePayload = (payload) => {
	const result = { ...payload };
	delete result._localKey;
	for (const month of FLOW_RATE_MONTHS) {
		const v = result[month];
		if (v === '' || v === null || v === undefined) {
			delete result[month];
		} else {
			result[month] = Number(v);
		}
	}
	return result;
};

if (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production') {
	const p = normalizeFlowRatePayload({ january: 0, february: '', march: '1.5', april: null, may: 10 });
	console.assert(p.january === 0 && p.march === 1.5 && !('february' in p) && !('april' in p), p);
}
